import {
  RouteReuseStrategy,
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
} from '@angular/router';
import {Injectable} from '@angular/core';

import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {KeyUtilsPL2 as KU} from '@common/utils/dist/utils/key-utils-pl2.js';
import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';

@Injectable()
export class AppRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  store(
    _route: ActivatedRouteSnapshot,
    _detachedTree: DetachedRouteHandle,
  ): void {}
  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }
  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    const rC = future.routeConfig;
    if (U.isEmpty(rC)) {
      return true;
    }
    if (future.params.containerId !== curr.params.containerId) {
      return false;
    }
    if (future.params.cardId !== curr.params.cardId) {
      return false;
    }
    if (this._isSwitchingUserInStudentCopy(future, curr)) {
      return false;
    }
    return future.routeConfig === curr.routeConfig;
  }

  private _isSwitchingUserInStudentCopy(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    const futureUEPK = future.queryParams.uEPK;
    const currUEPK = curr.queryParams.uEPK;
    const sameStudent = futureUEPK === currUEPK;

    const futureContainerId = future.params.containerId;
    const currContainerId = curr.params.containerId;
    const sameContainer = futureContainerId === currContainerId;

    const futureContainerIdType =
      futureContainerId && KU.type(futureContainerId);
    const currContainerIdType = futureContainerId && KU.type(currContainerId);
    const areBothStudentCopies =
      futureContainerIdType === PL2.EntryType.StudentCopy &&
      currContainerIdType === PL2.EntryType.StudentCopy;

    return !sameStudent && sameContainer && areBothStudentCopies;
  }
}
